import { render, staticRenderFns } from "./addIntegratedPerson.vue?vue&type=template&id=131a5eca&"
import script from "./addIntegratedPerson.vue?vue&type=script&lang=js&"
export * from "./addIntegratedPerson.vue?vue&type=script&lang=js&"
import style0 from "./addIntegratedPerson.vue?vue&type=style&index=0&id=131a5eca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports